import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AppSettingsService } from "../../../core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { IPackageAccess } from "../models/package-access.model";
import { IActivePermissionHoldersRequest } from "../models/active-permision-holders-request.model";
import { IRevokeAccessRequest } from "../models/revoke-active-permission-request.model";
import { IGLPManagerApprovalRequest } from "../models/glpmanager-approval-request.model";
import { IActivePermissionHoldersResponse } from "../models/active-permission-holders-response.model";
import { IGetRequests } from "../models/get-requests.model";
import { IRequesterDownloadRequest } from "../models/requester-download-request.model";
import { IRequesterPackageFolderResult } from "../models/requester-package-folder-result.model";

@Injectable()
export class RequesterAccessService {
  private appSettings = inject(AppSettingsService);
  private http = inject(HttpClient);

  private readonly accessBaseUrl = `${this.appSettings.baseApiUrl}/api/RequesterAccess`;
  private readonly downloadBaseUrl = `${this.appSettings.baseApiUrl}/api/RequesterDownload`;

  public CreatePackageFolderAccess(
    requestData: IPackageAccess
  ): Observable<boolean> {
    const url = `${this.accessBaseUrl}/create-package-folder-access`;
    return this.http.post<boolean>(url, requestData);
  }

  public GetActivePermissionHolders(
    request: IActivePermissionHoldersRequest
  ): Observable<IActivePermissionHoldersResponse[]> {
    return this.http.get<IActivePermissionHoldersResponse[]>(
      `${this.accessBaseUrl}/get-active-permission-holders?BucketItemId=${
        request.BucketItemId
      }&PackageId=${request.PackageId}&BUCode=${
        request.BUCode
      }&BucketType=${request.BucketType}`
    );
  }

  public RevokeAccess(request: IRevokeAccessRequest): Observable<boolean> {
    const url = `${this.accessBaseUrl}/revoke-active-permission`;
    return this.http.put<boolean>(url, request);
  }

  public GLPManagerApproval(
    request: IGLPManagerApprovalRequest
  ): Observable<boolean> {
    const url = `${this.accessBaseUrl}/glp-manager-approval`;
    return this.http.put<boolean>(url, request);
  }

  public GetRequests(pageNumber: number): Observable<IGetRequests> {
    return this.http.get<IGetRequests>(
      `${this.accessBaseUrl}/get-all-requests-by-user?pageNumber=${pageNumber}`
    );
  }

  public GetPackageFolderForRequester(
    requestId: string,
    parentId?: string
  ): Observable<IRequesterPackageFolderResult> {
    return this.http.get<IRequesterPackageFolderResult>(
      parentId
        ? `${this.accessBaseUrl}/get-package-folder-for-requester?requestId=${requestId}&parentId=${parentId}`
        : `${this.accessBaseUrl}/get-package-folder-for-requester?requestId=${requestId}`
    );
  }


  public downloadBucketItem(
    downloadItem: Partial<IRequesterDownloadRequest>
  ): Observable<HttpResponse<Blob>> {
    const url = `${this.downloadBaseUrl}/download`;
    return this.http.post<Blob>(url, downloadItem, {
      headers: new HttpHeaders({
        Authorization: "{withCredentials: true}",
        "Content-Type": "application/json",
      }),
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  
}
